import { Component, ElementRef, ViewChild, AfterViewChecked, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ChatService, ChatMessage } from '../../services/chat.service';
import { DataService } from '../../_services/data.service';
import { marked } from 'marked';

@Component({
  selector: 'app-chat-drawer',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './chat-drawer.component.html',
  styleUrls: ['./chat-drawer.component.scss'],
})
export class ChatDrawerComponent implements AfterViewChecked, OnInit, OnDestroy {
  open = false;
  input = '';
  messages: ChatMessage[] = [];
  loading = false;
  enabled = false;
  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;
  private shouldScroll = false;
  private sub$ = new Subscription();

  constructor(private chatService: ChatService, private dataService: DataService) {
    this.chatService.messages$.subscribe((m) => {
      this.messages = m;
      this.shouldScroll = true;
    });
    this.chatService.loading$.subscribe((l) => (this.loading = l));
  }

  ngOnInit() {
    this.dataService.getFeatures().subscribe((features: any) => {
      this.enabled = this.checkFeatureEnabled(features, 'system.ai');
    });
    const featuresSub$ = this.dataService.features$.asObservable().subscribe((features: any) => {
      this.enabled = this.checkFeatureEnabled(features, 'system.ai');
    });
    this.sub$.add(featuresSub$);
  }

  ngOnDestroy() {
    this.sub$.unsubscribe();
  }

  ngAfterViewChecked() {
    if (this.shouldScroll) {
      this.scrollToBottom();
      this.shouldScroll = false;
    }
  }

  toggle() {
    this.open = !this.open;
  }

  async send() {
    const text = this.input.trim();
    if (!text || this.loading) return;
    this.input = '';
    await this.chatService.sendMessage(text);
  }

  clear() {
    this.chatService.clear();
  }

  renderMarkdown(content: string): string {
    return marked.parse(content, { async: false }) as string;
  }

  trackByIndex(index: number) {
    return index;
  }

  private checkFeatureEnabled(features: any, featureName: string): boolean {
    if (features && features.length > 0) {
      const feature = features.find((f: any) => f.name === featureName);
      return feature && feature.enabled;
    }
    return false;
  }

  private scrollToBottom() {
    if (this.messagesContainer) {
      const el = this.messagesContainer.nativeElement;
      el.scrollTop = el.scrollHeight;
    }
  }
}
